import { createActions } from "redux-actions";

export const {
  getFoodProductList,
  setFoodProductList,
  addFoodProductToList,
  addFoodProductToListSuccess,
  addFoodProductToListFailure,
  deleteFoodProduct,
  deleteFoodProductSuccess,
  deleteFoodProductFailure,
  editFoodProduct,
  editFoodProductSuccess,
  editFoodProductFailure
} = createActions(
  {
    GET_FOOD_PRODUCT_LIST: (orderId, pagination, sort) => ({
      orderId,
      pagination,
      sort
    }),
    SET_FOOD_PRODUCT_LIST: foodProducts => ({ foodProducts })
  },
  "ADD_FOOD_PRODUCT_TO_LIST",
  "ADD_FOOD_PRODUCT_TO_LIST_SUCCESS",
  "ADD_FOOD_PRODUCT_TO_LIST_FAILURE",
  "DELETE_FOOD_PRODUCT",
  "DELETE_FOOD_PRODUCT_SUCCESS",
  "DELETE_FOOD_PRODUCT_FAILURE",
  "EDIT_FOOD_PRODUCT",
  "EDIT_FOOD_PRODUCT_SUCCESS",
  "EDIT_FOOD_PRODUCT_FAILURE"
);
